var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsGrid06Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_66173_157948)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_66173_157948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5007 4.00016C12.9609 4.00016 13.334 3.62707 13.334 3.16683C13.334 2.70659 12.9609 2.3335 12.5007 2.3335C12.0404 2.3335 11.6673 2.70659 11.6673 3.16683C11.6673 3.62707 12.0404 4.00016 12.5007 4.00016Z",
    stroke: "#98A2B3",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5007 9.8335C12.9609 9.8335 13.334 9.4604 13.334 9.00016C13.334 8.53993 12.9609 8.16683 12.5007 8.16683C12.0404 8.16683 11.6673 8.53993 11.6673 9.00016C11.6673 9.4604 12.0404 9.8335 12.5007 9.8335Z",
    stroke: "#98A2B3",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5007 15.6668C12.9609 15.6668 13.334 15.2937 13.334 14.8335C13.334 14.3733 12.9609 14.0002 12.5007 14.0002C12.0404 14.0002 11.6673 14.3733 11.6673 14.8335C11.6673 15.2937 12.0404 15.6668 12.5007 15.6668Z",
    stroke: "#98A2B3",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66732 4.00016C7.12755 4.00016 7.50065 3.62707 7.50065 3.16683C7.50065 2.70659 7.12755 2.3335 6.66732 2.3335C6.20708 2.3335 5.83398 2.70659 5.83398 3.16683C5.83398 3.62707 6.20708 4.00016 6.66732 4.00016Z",
    stroke: "#98A2B3",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66732 9.8335C7.12755 9.8335 7.50065 9.4604 7.50065 9.00016C7.50065 8.53993 7.12755 8.16683 6.66732 8.16683C6.20708 8.16683 5.83398 8.53993 5.83398 9.00016C5.83398 9.4604 6.20708 9.8335 6.66732 9.8335Z",
    stroke: "#98A2B3",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66732 15.6668C7.12755 15.6668 7.50065 15.2937 7.50065 14.8335C7.50065 14.3733 7.12755 14.0002 6.66732 14.0002C6.20708 14.0002 5.83398 14.3733 5.83398 14.8335C5.83398 15.2937 6.20708 15.6668 6.66732 15.6668Z",
    stroke: "#98A2B3",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_66173_157948",
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_66173_157948"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_66173_157948",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66173_157948"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 1H12C15.3137 1 18 3.68629 18 7V11C18 14.3137 15.3137 17 12 17H2V1Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsGrid06Icon);
export default __webpack_public_path__ + "static/media/dots-grid-06-icon.2696c2d884cb798f80b8d92f970c8c57.svg";
export { ForwardRef as ReactComponent };